export var SLICE = "userManagement";
// getUserProfileInfo action types.
var GET_USER_PROFILE_INFO_ACTIONS = "".concat(SLICE, "/GET_USER_PROFILE_INFO_ACTIONS");
export var GET_USER_PROFILE_INFO_ACTIONS_REQUEST = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/REQUEST");
export var GET_USER_PROFILE_INFO_ACTIONS_SUCCESS = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/SUCCESS");
export var GET_USER_PROFILE_INFO_ACTIONS_FAILURE = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/FAILURE");
// updateUserProfileInfo action types.
export var UPDATE_USER_PROFILE_INFO_ACTION_TYPE = "".concat(SLICE, "/UPDATE_USER_PROFILE_INFO");
export var UPDATE_USER_PROFILE_INFO_REQUEST = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_REQUEST");
export var UPDATE_USER_PROFILE_INFO_SUCCESS = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_SUCCESS");
export var UPDATE_USER_PROFILE_INFO_FAILURE = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_FAILURE");
// updateUserLocale action types.
export var UPDATE_USER_LOCALE_ACTION_TYPE = "".concat(SLICE, "/UPDATE_USER_LOCALE");
export var UPDATE_USER_LOCALE_REQUEST = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_REQUEST");
export var UPDATE_USER_LOCALE_SUCCESS = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_SUCCESS");
export var UPDATE_USER_LOCALE_FAILURE = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_FAILURE");
// accept Invitation
export var ACCEPT_INVITATION_ACTION_TYPE = "".concat(SLICE, "/ACCEPT_INVITATION");
export var ACCEPT_INVITATION_REQUEST = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_REQUEST");
export var ACCEPT_INVITATION_SUCCESS = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_SUCCESS");
export var ACCEPT_INVITATION_FAILURE = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_FAILURE");
// create invitation
export var CREATE_INVITATION_ACTION_TYPE = "".concat(SLICE, "/CREATE_INVITATION");
export var CREATE_INVITATION_REQUEST = "".concat(CREATE_INVITATION_ACTION_TYPE, "_REQUEST");
export var CREATE_INVITATION_SUCCESS = "".concat(CREATE_INVITATION_ACTION_TYPE, "_SUCCESS");
export var CREATE_INVITATION_FAILURE = "".concat(CREATE_INVITATION_ACTION_TYPE, "_FAILURE");
export var CREATE_INVITATION_SUCCESS_RESET = "".concat(CREATE_INVITATION_ACTION_TYPE, "_SUCCESS_RESET");
// resend invitation
export var RESEND_INVITATION_ACTION_TYPE = "".concat(SLICE, "/RESEND_INVITATION");
export var RESEND_INVITATION_REQUEST = "".concat(RESEND_INVITATION_ACTION_TYPE, "_REQUEST");
export var RESEND_INVITATION_SUCCESS = "".concat(RESEND_INVITATION_ACTION_TYPE, "_SUCCESS");
export var RESEND_INVITATION_FAILURE = "".concat(RESEND_INVITATION_ACTION_TYPE, "_FAILURE");
// delete invitation
export var DELETE_INVITATION_ACTION_TYPE = "".concat(SLICE, "/DELETE_INVITATION");
export var DELETE_INVITATION_REQUEST = "".concat(DELETE_INVITATION_ACTION_TYPE, "_REQUEST");
export var DELETE_INVITATION_SUCCESS = "".concat(DELETE_INVITATION_ACTION_TYPE, "_SUCCESS");
export var DELETE_INVITATION_FAILURE = "".concat(DELETE_INVITATION_ACTION_TYPE, "_FAILURE");
// confirm invitation
export var CONFIRM_INVITATION_ACTION_TYPE = "".concat(SLICE, "/CONFIRM_INVITATION");
export var CONFIRM_INVITATION_REQUEST = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_REQUEST");
export var CONFIRM_INVITATION_SUCCESS = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_SUCCESS");
export var CONFIRM_INVITATION_FAILURE = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_FAILURE");
// getUsersForLogisticsParty
export var GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = "".concat(SLICE, "/GET_USERS_FOR_LOGISTICS_PARTY");
export var GET_USERS_FOR_LOGISTICS_PARTY_REQUEST = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_REQUEST");
export var GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_SUCCESS");
export var GET_USERS_FOR_LOGISTICS_PARTY_FAILURE = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_FAILURE");
// getInvitedUsersForLogisticsParty
export var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = "".concat(SLICE, "/GET_INVITED_USERS_FOR_LOGISTICS_PARTY");
export var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_REQUEST");
export var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_SUCCESS");
export var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_FAILURE");
// deactivateUser
export var DEACTIVATE_USER_ACTION_TYPE = "".concat(SLICE, "/DEACTIVATE_USER_ACTION_TYPE");
export var DEACTIVATE_USER_REQUEST = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_REQUEST");
export var DEACTIVATE_USER_SUCCESS = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_SUCCESS");
export var DEACTIVATE_USER_FAILURE = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_FAILURE");
// getDeactivatedUsers
export var GET_DEACTIVATED_USERS_ACTION_TYPE = "".concat(SLICE, "/GET_DEACTIVATED_USES_ACTION_TYPE");
export var GET_DEACTIVATED_USERS_REQUEST = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_REQUEST");
export var GET_DEACTIVATED_USERS_SUCCESS = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_SUCCESS");
export var GET_DEACTIVATED_USERS_FAILURE = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_FAILURE");
// fetchUserDetails
export var FETCH_USER_DETAILS = "".concat(SLICE, "/FETCH_USER_DETAILS");
export var FETCH_USER_DETAILS_REQUEST = "".concat(FETCH_USER_DETAILS, "_REQUEST");
export var FETCH_USER_DETAILS_SUCCESS = "".concat(FETCH_USER_DETAILS, "_SUCCESS");
export var FETCH_USER_DETAILS_FAILURE = "".concat(FETCH_USER_DETAILS, "_FAILURE");

//# sourceMappingURL=actionTypes.js.map